import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigurationDataProvider } from '../providers/configuration-data-provider';
import { SharedDataProvider } from '../providers/shared-data-provider';

/*
  Generated class for the LoginProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class LoginProvider {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  /*
  Calls login api to obtain api token for further api calls.
  */
  public login(user: string, password: string): any {
    let body = { username: user, password: password };
    console.log('Login provider called.');

    return this.http.post(this.config.apiURL + "user/login", JSON.stringify(body), { headers: this.headers });
  }

  public loadMyDetails() {
    console.log('Load details was triggered.');
    return this.http.post(this.config.apiURL + "user/mydetails", JSON.stringify(this.shared.getTokenAuthData()),
      { headers: this.headers });
  }

  constructor(public http: HttpClient, private config: ConfigurationDataProvider,
    private shared: SharedDataProvider) {
    console.log('Hello LoginProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/login-provider.ts